import Header from "./Header";
import Sidebar from "./Sider";
import BottomNav from "../components/BottomNav";
import { useSelector } from "react-redux";


const AppLayout = ({ children, showSider = true, showHeader = true }) => {
    const mode = useSelector(state => state.mode.mode);

    return (
        <div className={`app-container ${mode === 'private' && "private-mode-active"}`}>
            {showSider && <Sidebar />}

            <div className="main-content">
                {showHeader && <Header />}

                <main className="content-area">{children}</main>

                {showSider && <BottomNav />}
            </div>
        </div>
    );
};

export default AppLayout;